const campaignId = window.location.pathname.split('/')[3];

export const campaignTypes: any = {
	closing: 'nom035-closing',
	evaluation: 'nom035-evaluation',
	introduction: 'nom035-introduction',
	sensitization: 'nom035-sensitization',
};

export const stepperOptions = [
	{
		id: 0,
		name: 'Introducción',
		type: 'introduction',
		title: 'Introducción a la NOM - 035',
		description:
			'Crea un envío de comunicación por correo para informar a tus colaboradores sobre la NOM 035 su proposito y las fases de las que está conformada',
	},
	{
		id: 1,
		name: 'Sensibilización',
		type: 'sensitization',
		title: 'Información de la evaluación',
		description:
			'Crea un envío de comunicación a tus colaboradores para informar de la evaluación que se realizará, incluye la definición de cada cuestionario',
	},
	{
		id: 2,
		name: 'Evaluación',
		type: 'evaluation',
		title: 'Comienza la evaluación',
		description:
			'Crea un envío de comunicación con el objetivo de que los colaboradores comiencen a responder la evaluación.  El enlace a la evaluación es añadido automaticamente.',
	},
	{
		id: 3,
		name: 'Cierre',
		type: 'closing',
		title: 'Cierre de las evaluaciones',
		description:
			'Crea un envío para comunicar que se han cerrado las evaluaciones, agradece a tus colaboradores por su participación',
	},
];

export const superscriptionItems: any = [
	{ name: 'Introducción a la NOM 035', color: '#8CF07E', type: 'introduction' },
	{
		name: 'Definición de evaluaciones',
		color: '#1AB0E6',
		type: 'sensitization',
	},
	{ name: 'Lanzamiento de evaluaciones', color: '#5082C2', type: 'evaluation' },
	{ name: 'Cierre de evaluaciones', color: '#C22A58', type: 'closing' },
];

export const acceptedFileTypes = [
	'image/png',
	'image/jpg',
	'image/jpeg',
	'image/gif',
	'application/pdf',
];

export const initialCampaign = {
	introduction: {
		campaignId: campaignId,
		communicationTypeId: '',
		name: '',
		messageTitle: '',
		messageBody: '',
		messageFile: '',
		sendingDate: undefined,
		sendingTime: '',
		useCustomTemplate: false,
	},
	sensitization: {
		campaignId: campaignId,
		communicationTypeId: '',
		name: '',
		messageTitle: '',
		messageBody: '',
		messageFile: '',
		sendingDate: undefined,
		sendingTime: '',
		useCustomTemplate: false,
	},
	evaluation: {
		campaignId: campaignId,
		communicationTypeId: '',
		name: '',
		messageTitle: '',
		messageBody: '',
		messageFile: '',
		sendingDate: undefined,
		sendingTime: '',
		useCustomTemplate: false,
	},
	closing: {
		campaignId: campaignId,
		communicationTypeId: '',
		name: '',
		messageTitle: '',
		messageBody: '',
		messageFile: '',
		sendingDate: undefined,
		sendingTime: '',
		useCustomTemplate: false,
	},
};

export const hours = [
	{
		id: 0,
		value: '06:00',
	},
	{
		id: 1,
		value: '06:30',
	},
	{
		id: 2,
		value: '07:00',
	},
	{
		id: 3,
		value: '07:30',
	},
	{
		id: 4,
		value: '08:00',
	},
	{
		id: 5,
		value: '08:30',
	},
	{
		id: 6,
		value: '09:00',
	},
	{
		id: 7,
		value: '09:30',
	},
	{
		id: 8,
		value: '10:00',
	},
	{
		id: 9,
		value: '10:30',
	},
	{
		id: 10,
		value: '11:00',
	},
	{
		id: 11,
		value: '11:30',
	},
	{
		id: 12,
		value: '12:00',
	},
	{
		id: 13,
		value: '12:30',
	},
	{
		id: 14,
		value: '13:00',
	},
	{
		id: 15,
		value: '13:30',
	},
	{
		id: 16,
		value: '14:00',
	},
	{
		id: 17,
		value: '14:30',
	},
	{
		id: 18,
		value: '15:00',
	},
	{
		id: 19,
		value: '15:30',
	},
	{
		id: 20,
		value: '16:00',
	},
	{
		id: 21,
		value: '16:30',
	},
	{
		id: 22,
		value: '17:00',
	},
	{
		id: 23,
		value: '17:30',
	},
	{
		id: 24,
		value: '18:00',
	},
	{
		id: 25,
		value: '18:30',
	},
	{
		id: 26,
		value: '19:00',
	},
	{
		id: 27,
		value: '19:30',
	},
	{
		id: 28,
		value: '20:00',
	},
	{
		id: 29,
		value: '20:30',
	},
	{
		id: 30,
		value: '21:00',
	},
	{
		id: 31,
		value: '21:30',
	},
	{
		id: 32,
		value: '22:00',
	},
	{
		id: 33,
		value: '22:30',
	},
	{
		id: 34,
		value: '23:00',
	},
	{
		id: 35,
		value: '23:30',
	},
	{
		id: 36,
		value: '00:00',
	},
	{
		id: 37,
		value: '00:30',
	},
	{
		id: 38,
		value: '01:00',
	},
	{
		id: 39,
		value: '01:30',
	},
	{
		id: 40,
		value: '02:00',
	},
	{
		id: 41,
		value: '02:30',
	},
	{
		id: 42,
		value: '03:00',
	},
	{
		id: 43,
		value: '03:30',
	},
	{
		id: 44,
		value: '04:00',
	},
	{
		id: 45,
		value: '04:30',
	},
	{
		id: 46,
		value: '05:00',
	},
	{
		id: 47,
		value: '05:30',
	},
];
